import {types} from './types';

const setGetBonusesPersonalAction = (payload) => {
    return {
        type: types.SET_PERSONAL_BONUSES,
        payload,
      }
}

const setGetBonusesHistoryAction = (payload) => {
  return {
    type: types.SET_HISTORY_BONUSES,
    payload
  }
}

export {
  setGetBonusesPersonalAction,
  setGetBonusesHistoryAction
}